import { sapApi } from "@/apis/interceptor"
import { IProductMaster, IResponse } from "@/types"

interface IProductMasterAutocompleteResponse {
  items: IProductMaster[]
}

export const productMasterService = {
  getAutocompleteOptions: async (search: string, limit = 10): Promise<IResponse<IProductMasterAutocompleteResponse>> => {
    const response = await sapApi.get<IResponse<IProductMasterAutocompleteResponse>>("/api/v1/product-masters/autocomplete", {
      params: { search, limit },
    })
    return response.data
  },
}
